<!-- <div class="base" 
  *ngIf="vinInfo['vin_number'].value || vinInfo['vehicle_item_code']">
  <div class="base__info ml-auto">
    <span class="base__infoItem mb-2"><span class="font-weight-medium">VIN No.:</span> {{ vinInfo['vin_number'].value }}</span>
    <span class="base__infoItem"><span class="font-weight-medium">Item Code:</span> {{ vinInfo['vehicle_item_code'] }}</span>
  </div>
</div> -->

<section class="vam_ratings_section rating pb-5">
  <div class="container">
    <div class="row">
      <div class="col-md-6 vam_ratings_tabs_contaier mt-3">
        <div class="ratings_tab_main_container p-2">
          <ul class="nav nav-tabs border-0">
            <li class="col-6 col-sm-4 ratings_tabs nav-item px-1">
              <a
                class="tablinks analytics_tablinks ratings_tablink ratings_tablink_one nav-link"
                href="javascript:void(0)"
                routerLink="/vam/commonrating/exterior"
                routerLinkActive="active"
                (click)="exteriorShow()"
              >
                <svg class="rating_tab_icon" viewBox="0 0 25.507 26.898">
                  <g transform="translate(0 0)">
                    <g transform="translate(0)">
                      <path
                        d="M9.049,12.848A4.6,4.6,0,0,1,13.606,17.2l.761.572a4.183,4.183,0,0,1,1.665,3.342v3.5A2.846,2.846,0,0,1,13.2,27.456L.392,27.467v-.928l12.8-.011A1.9,1.9,0,0,0,15.1,24.614v-3.5a3.254,3.254,0,0,0-1.3-2.6l-1.076-.81v-.23a3.685,3.685,0,0,0-3.683-3.7H1.937a3.648,3.648,0,0,0-1.433.29l-.362-.853a4.584,4.584,0,0,1,1.8-.364H9.049Z"
                        transform="translate(-0.142 -3.585)"
                      />
                      <path
                        d="M13.73,18.925l.3.88-1.248.417a3.894,3.894,0,0,1-1.234.2L.482,20.481l0-.928L11.54,19.5a2.97,2.97,0,0,0,.944-.154Z"
                        transform="translate(-0.23 -5.177)"
                      />
                      <path
                        d="M16.12,26.586a2.847,2.847,0,0,1-2.833,2.844L.481,29.441v-.928l12.8-.011a1.906,1.906,0,0,0,1.908-1.917Z"
                        transform="translate(-0.231 -7.184)"
                      />
                      <path
                        d="M17.288,32.07v2.379a1.064,1.064,0,0,1-1.056,1.058H15.047a1.064,1.064,0,0,1-1.056-1.058V32.07h.928v2.379a.123.123,0,0,0,.129.13h1.185a.123.123,0,0,0,.129-.13V32.07Z"
                        transform="translate(-3.77 -8.62)"
                      />
                      <path
                        d="M15.639,22.924a1.653,1.653,0,1,1-1.649,1.652A1.657,1.657,0,0,1,15.639,22.924Zm0,.928a.726.726,0,1,0,.721.725A.715.715,0,0,0,15.639,23.851Z"
                        transform="translate(-3.77 -6.224)"
                      />
                      <path
                        d="M19.609,16.878a1.658,1.658,0,0,1,1.649,1.654v.594A1.064,1.064,0,0,1,20.2,20.184h-.928v-.928H20.2a.123.123,0,0,0,.129-.13v-.594a.717.717,0,0,0-.721-.726H17.83v-.928Z"
                        transform="translate(-4.776 -4.641)"
                      />
                      <path
                        class="c"
                        d="M8.365,22.9a.464.464,0,0,1,.455.554l-.464,2.319a.464.464,0,0,1-.455.373l-7.42.011v-.928l7.04-.011L7.8,23.827l-7.319.011V22.91Z"
                        transform="translate(-0.231 -6.218)"
                      />
                      <path
                        d="M25.98.3a5.1,5.1,0,1,0,5.1,5.1A5.108,5.108,0,0,0,25.98.3Zm0,.928A4.174,4.174,0,1,1,21.806,5.4,4.167,4.167,0,0,1,25.98,1.224Z"
                        transform="translate(-5.574 -0.297)"
                      />
                      <path
                        d="M27.162,13.493v14.84h.928V13.493Z"
                        transform="translate(-7.22 -3.754)"
                      />
                      <path
                        d="M26.668,32.973a1.4,1.4,0,0,0-1.391,1.391v1.391h3.71V34.364A1.4,1.4,0,0,0,27.6,32.973Zm0,.928H27.6a.457.457,0,0,1,.464.464v.464H26.2v-.464a.457.457,0,0,1,.464-.464Z"
                        transform="translate(-6.727 -8.857)"
                      />
                    </g>
                  </g>
                </svg>
                {{ 'nav_exterior' | translate }}
              </a>
            </li>

            <li class="col-6 col-sm-4 ratings_tabs nav-item px-1">
              <a
                class="tablinks analytics_tablinks ratings_tablink nav-link"
                href="javascript:void(0)"
                routerLink="/vam/commonrating/interior"
                routerLinkActive="active"
                (click)="exteriorShow()"
              >
                <svg class="rating_tab_icon" viewBox="0 0 23.617 21.784">
                  <g transform="translate(-169.746 -39.472)">
                    <path
                      d="M22.376,2.839a3.512,3.512,0,0,0-1.423-.348,1.673,1.673,0,0,0-1.428.647.566.566,0,0,0-.059.118c-1.687,4.625-4.47,5.1-4.582,5.115a.634.634,0,0,0-.076.015c-.266.071-.512.152-.744.239a2.478,2.478,0,0,0-.211-.491,3.776,3.776,0,0,0,3.335-3.71,3.828,3.828,0,0,0-7.654,0,3.692,3.692,0,0,0,1.2,2.714c-2.087.266-5.854.826-6.038.853a.589.589,0,0,0-.409.262,2.369,2.369,0,0,0,.15,2.942.6.6,0,0,0,.416.168H8.877a1.494,1.494,0,0,1-1.464.917l-.265-.025C5.4,12.1,4.131,11.978,2.6,13.432A30.381,30.381,0,0,0,.127,16.069a.565.565,0,0,0-.1.534,2.191,2.191,0,0,0,1.783,1.392,20.735,20.735,0,0,0-.273,2.759.569.569,0,0,0,.166.417.6.6,0,0,0,.421.174H12.376a4.309,4.309,0,0,0,3.9-2.253l7.21-14.022.014-.029A1.7,1.7,0,0,0,22.376,2.839ZM13.362,1.832a2.626,2.626,0,0,1,2.651,2.594,2.652,2.652,0,0,1-5.3,0A2.627,2.627,0,0,1,13.362,1.832ZM1.292,16.493a30.661,30.661,0,0,1,2.123-2.235c1.145-1.085,1.921-1.013,3.621-.855l.268.025a2.936,2.936,0,0,0,2.984-2.523.566.566,0,0,0-.121-.478.593.593,0,0,0-.455-.211H5.133a1.255,1.255,0,0,1,.034-1.129C6.3,8.92,10.355,8.326,11.73,8.18a1.052,1.052,0,0,1,1.237.9.566.566,0,0,0,.019.069,5.524,5.524,0,0,0-2.463,4.438,7.662,7.662,0,0,1-.13.767.531.531,0,0,1-.6.462,1.772,1.772,0,0,1-.545-.1.646.646,0,0,0-.085-.026,8.335,8.335,0,0,0-1.845-.2c-2.435,0-4.477,1.023-5.043,2.013a2.631,2.631,0,0,0-.167.369A1.086,1.086,0,0,1,1.292,16.493ZM22.429,4.577,15.223,18.59A3.145,3.145,0,0,1,12.376,20.2H2.742A9.99,9.99,0,0,1,3.3,17.061c.293-.511,1.886-1.425,4.018-1.425A7.153,7.153,0,0,1,8.86,15.8a2.966,2.966,0,0,0,.932.161,1.684,1.684,0,0,0,1.741-1.334,8.5,8.5,0,0,0,.155-.89c.214-1.532.48-3.438,3.4-4.236.441-.077,3.591-.792,5.442-5.751a.685.685,0,0,1,.42-.112,2.353,2.353,0,0,1,.931.243C22.491,4.157,22.466,4.464,22.429,4.577Z"
                      transform="translate(169.746 39.91)"
                    />
                    <circle
                      class="c"
                      cx="3.69"
                      cy="3.69"
                      r="3.69"
                      transform="translate(179.34 40.222)"
                    />
                  </g>
                </svg>
                {{ 'nav_interior' | translate }}
              </a>
            </li>

            <li class="col-6 col-sm-4 ratings_tabs nav-item px-1">
              <a
                class="tablinks analytics_tablinks ratings_tablink nav-link"
                href="javascript:void(0)"
                routerLink="/vam/commonrating/mechanics"
                routerLinkActive="active"
                (click)="exteriorShow()"
              >
                <svg class="rating_tab_icon" viewBox="0 0 23.012 20.676">
                  <path
                    d="M23.3,8.811l-1.244-.117a6.47,6.47,0,0,0-.607-1.436l.788-.952a.583.583,0,0,0-.035-.782L20.649,3.953a.584.584,0,0,0-.788-.041l-.952.788a6.711,6.711,0,0,0-1.431-.607l-.117-1.238a.584.584,0,0,0-.584-.526H14.84V.584a.584.584,0,1,0-1.168,0V3.5H11.465A3.04,3.04,0,0,0,9.059,4.695L6.647,7.859,2.6,8.963A2.419,2.419,0,0,0,.82,11.293V12.84a2.421,2.421,0,0,0,2.423,2.406h.315a3.052,3.052,0,0,0,5.892,0h4.222v4.846a.584.584,0,1,0,1.168,0v-1.4h1.939a.584.584,0,0,0,.584-.531l.117-1.244a6.738,6.738,0,0,0,1.436-.6l.952.788a.582.582,0,0,0,.782-.035L22.22,15.5a.59.59,0,0,0,.035-.788l-.788-.952a6.84,6.84,0,0,0,.607-1.431l1.226-.117a.589.589,0,0,0,.531-.584V9.4A.59.59,0,0,0,23.3,8.811ZM6.507,16.338a1.886,1.886,0,1,1,1.886-1.886A1.889,1.889,0,0,1,6.507,16.338Zm7.165-2.266H9.538a3.053,3.053,0,0,0-6.061,0H3.243a1.246,1.246,0,0,1-1.255-1.238V11.287a1.261,1.261,0,0,1,.923-1.2L7.144,8.928a.57.57,0,0,0,.309-.21L9.981,5.4a1.856,1.856,0,0,1,1.477-.73h2.213ZM14.84,8.029a2.611,2.611,0,1,1,0,4.957Zm7.824,3.06-1.109.105a.584.584,0,0,0-.514.455,5.534,5.534,0,0,1-.777,1.833.579.579,0,0,0,.041.689l.712.864-.817.817-.864-.707a.579.579,0,0,0-.695-.035,5.326,5.326,0,0,1-1.828.771.577.577,0,0,0-.455.514l-.105,1.121H14.84V14.195A3.778,3.778,0,1,0,16.48,6.82a3.705,3.705,0,0,0-1.641,0V3.5h1.407l.111,1.115a.584.584,0,0,0,.455.514,5.646,5.646,0,0,1,1.833.771.579.579,0,0,0,.689-.041l.858-.712L21,5.962l-.718.87a.579.579,0,0,0-.035.695,5.326,5.326,0,0,1,.771,1.828.583.583,0,0,0,.52.455l1.127.111v1.168Z"
                    transform="translate(-0.82)"
                  />
                  <circle class="c" cx="2.5" cy="2.5" r="2.5" transform="translate(2.922 12.147)" />
                </svg>
                {{ 'nav_mechanics' | translate }}
              </a>
            </li>

            <li class="col-6 col-sm-4 ratings_tabs nav-item px-1">
              <a
                class="tablinks analytics_tablinks ratings_tablink nav-link"
                href="javascript:void(0)"
                routerLink="/vam/commonrating/frame"
                routerLinkActive="active"
                (click)="exteriorShow()"
              >
                <svg class="rating_tab_icon" viewBox="0 0 22.25 23.633">
                  <g transform="translate(0 0)">
                    <path
                      d="M6.2,19.254h9.845v2.383a2,2,0,0,0,1.995,2h1.569a2,2,0,0,0,1.994-2V15.625a2,2,0,0,0-1.994-1.994H18.042a2,2,0,0,0-1.995,1.994v2.385H11.618V14.336a2.371,2.371,0,0,0,0-4.578V6.186H16L15.453,8.6a2,2,0,0,0,1.506,2.384l1.531.346a2.006,2.006,0,0,0,.442.05,1.984,1.984,0,0,0,1.944-1.556L22.2,3.957a2,2,0,0,0-1.506-2.384l-1.531-.346a1.994,1.994,0,0,0-2.384,1.506l-.5,2.209H6.308L6.8,2.779A2,2,0,0,0,5.29.394L3.759.049A2.009,2.009,0,0,0,3.318,0,1.983,1.983,0,0,0,1.374,1.555L.049,7.421A2,2,0,0,0,1.556,9.805l1.531.345a2.006,2.006,0,0,0,.442.05A1.982,1.982,0,0,0,5.471,8.644l.555-2.458h4.347V9.758a2.371,2.371,0,0,0,0,4.578v3.673H6.2V15.625a2,2,0,0,0-1.995-1.994H2.638A2,2,0,0,0,.644,15.625v6.013a2,2,0,0,0,1.994,2h1.57a2,2,0,0,0,1.995-2Zm11.09-3.63a.751.751,0,0,1,.75-.75h1.569a.75.75,0,0,1,.75.75v6.013a.751.751,0,0,1-.75.751H18.042a.751.751,0,0,1-.75-.751Zm.7-12.618a.755.755,0,0,1,.73-.585.767.767,0,0,1,.166.018l1.531.346a.751.751,0,0,1,.567.9L19.662,9.548a.752.752,0,0,1-.9.566l-1.531-.346a.751.751,0,0,1-.566-.9ZM4.257,8.371a.749.749,0,0,1-.9.566L1.83,8.591a.751.751,0,0,1-.567-.9L2.588,1.829a.748.748,0,0,1,.9-.566l1.53.345a.752.752,0,0,1,.567.9Zm5.609,3.677A1.13,1.13,0,1,1,11,13.177,1.132,1.132,0,0,1,9.865,12.047ZM4.958,21.638a.751.751,0,0,1-.75.751H2.638a.751.751,0,0,1-.75-.751V15.625a.75.75,0,0,1,.75-.75h1.57a.75.75,0,0,1,.75.75Z"
                      transform="translate(0)"
                    />
                    <ellipse
                      class="c"
                      cx="2"
                      cy="2.5"
                      rx="2"
                      ry="2.5"
                      transform="translate(9.051 9.372)"
                    />
                  </g>
                </svg>
                {{ 'nav_frame' | translate }}
              </a>
            </li>

            <li class="col-6 col-sm-4 ratings_tabs nav-item px-1">
              <a
                class="tablinks analytics_tablinks ratings_tablink nav-link"
                href="javascript:void(0)"
                routerLink="/vam/commonrating/major-options"
                routerLinkActive="active"
                (click)="exteriorShow()"
              >
                <svg class="rating_tab_icon" viewBox="0 0 22.693 28.34">
                  <g transform="translate(0)">
                    <path
                      d="M1.59,4.157.641,8.907A1.242,1.242,0,0,0,.924,9.914a1.48,1.48,0,0,0,1.129.478H11.5v2.241l-2.671,4.9-4.509.9a.472.472,0,0,0-.218.819l3.561,3.117L6.318,27.754A.472.472,0,0,0,7,28.283l4.969-2.711,4.969,2.711a.472.472,0,0,0,.684-.529l-1.347-5.388,3.561-3.117a.472.472,0,0,0-.216-.818l-4.507-.9-2.672-4.9V10.391h9.447a1.48,1.48,0,0,0,1.129-.478A1.254,1.254,0,0,0,23.3,8.882l-.94-4.7a1.548,1.548,0,0,0-1.412-1.35H14.334V0H9.61V2.834H3A1.538,1.538,0,0,0,1.59,4.157ZM11.972,16.532A.472.472,0,1,1,11.5,17,.472.472,0,0,1,11.972,16.532ZM5.447,19.169l3.513-.7,2.157,2.516-2.8.7ZM11.5,24.753l-4,2.184,1.086-4.348L11.5,21.86Zm4.949,2.184-4-2.184V21.86l2.917.729ZM18.5,19.169l-2.872,2.513-2.8-.7,2.157-2.514Zm-4.262-1.28L11.972,20.53,9.709,17.889,11.5,14.605v1.069a1.417,1.417,0,1,0,.945,0V14.605Zm6.711-14.11c.2,0,.439.272.482.567l.94,4.7a.3.3,0,0,1-.062.254.553.553,0,0,1-.415.15H13.585l1.083-1.083L14,7.7,12.249,9.447H11.223l5.668-5.668Zm-5.391,0L9.887,9.447H7.917l5.668-5.668Zm-5-2.834h2.834V2.834H10.555ZM9.887,3.779,6.915,6.751l.668.668,3.64-3.64h1.026L6.581,9.447H2.053A.553.553,0,0,1,1.638,9.3a.289.289,0,0,1-.067-.226L2.521,4.32c.038-.269.279-.541.477-.541Z"
                      transform="translate(-0.625)"
                    />
                    <path d="M0,0H1.336V.945H0Z" transform="translate(13.847 7.223) rotate(-45)" />
                    <rect width="0.945" height="0.945" transform="translate(7.096 19.366)" />
                    <rect width="0.945" height="0.945" transform="translate(12.764 23.145)" />
                    <path
                      class="c"
                      d="M23.146,19.474H19.84v.945h3.306a1.889,1.889,0,1,0-1.889-1.889H22.2a.945.945,0,1,1,.945.945Z"
                      transform="translate(-5.659 -4.359)"
                    />
                    <rect
                      class="c"
                      width="6.14"
                      height="0.945"
                      transform="translate(2.373 15.115)"
                    />
                    <rect
                      class="c"
                      width="4.251"
                      height="0.945"
                      transform="translate(4.735 13.225)"
                    />
                  </g>
                </svg>
                {{ 'nav_major_options' | translate }}
              </a>
            </li>

            <li class="col-6 col-sm-4 ratings_tabs nav-item px-1">
              <a
                class="tablinks analytics_tablinks ratings_tablink nav-link"
                href="javascript:void(0)"
                routerLink="/vam/commonrating/grading"
                routerLinkActive="active"
                (click)="exteriorHide()"
              >
                <svg class="rating_tab_icon" viewBox="0 0 26.189 21.842">
                  <g transform="translate(0 0)">
                    <g transform="translate(0)">
                      <path
                        class="c"
                        d="M21.886,10.9A65,65,0,0,0,15.2,14.424a2.458,2.458,0,0,0,3.276,3.666,64.766,64.766,0,0,0,4.253-6.246.66.66,0,0,0-.844-.945ZM17.6,17.106a1.139,1.139,0,0,1-1.519-1.7,40.927,40.927,0,0,1,4.29-2.3A40.753,40.753,0,0,1,17.6,17.106Z"
                        transform="translate(-4.013 -2.998)"
                      />
                      <path
                        d="M13.427.216A13.091,13.091,0,0,0,3.485,21.828a.659.659,0,0,0,.837.138,18.422,18.422,0,0,1,9.105-2.184,18.429,18.429,0,0,1,9.106,2.184.66.66,0,0,0,.837-.138A13.091,13.091,0,0,0,13.427.216ZM22.71,20.551a19.939,19.939,0,0,0-9.282-2.089,19.934,19.934,0,0,0-9.282,2.089,11.775,11.775,0,1,1,18.565,0Z"
                        transform="translate(-0.332 -0.216)"
                      />
                      <path
                        d="M17.841,6.646a.66.66,0,0,0,.66-.66V4.244a.66.66,0,0,0-1.32,0V5.986A.66.66,0,0,0,17.841,6.646Z"
                        transform="translate(-4.746 -1.099)"
                      />
                      <path
                        d="M28.3,17.725a.66.66,0,0,0,.66.66H30.7a.66.66,0,0,0,0-1.32H28.961A.66.66,0,0,0,28.3,17.725Z"
                        transform="translate(-7.659 -4.63)"
                      />
                      <path
                        d="M6.762,17.725a.66.66,0,0,0-.66-.66H4.36a.66.66,0,0,0,0,1.32H6.1A.66.66,0,0,0,6.762,17.725Z"
                        transform="translate(-1.215 -4.63)"
                      />
                      <path
                        d="M27.143,11.329a.66.66,0,0,0,.664,1.141l1.506-.876a.66.66,0,1,0-.663-1.141Z"
                        transform="translate(-7.27 -2.875)"
                      />
                      <path
                        d="M7.377,22.812l-1.505.875a.66.66,0,1,0,.663,1.141l1.505-.875a.66.66,0,0,0-.663-1.141Z"
                        transform="translate(-0.697 -6.112)"
                      />
                      <path
                        d="M23.092,8.225a.659.659,0,0,0,.9-.246l.863-1.514a.66.66,0,1,0-1.146-.654l-.863,1.514A.659.659,0,0,0,23.092,8.225Z"
                        transform="translate(-6.208 -1.595)"
                      />
                      <path
                        d="M11.882,5.846a.66.66,0,1,0-1.142.66l.871,1.508a.66.66,0,0,0,1.142-.66Z"
                        transform="translate(-3.035 -1.605)"
                      />
                      <path
                        d="M8.251,11.384,6.74,10.517a.66.66,0,0,0-.657,1.144l1.511.867a.66.66,0,1,0,.657-1.144Z"
                        transform="translate(-1.752 -2.892)"
                      />
                      <path
                        d="M29.589,23.624l-1.509-.866a.66.66,0,0,0-.657,1.145l1.509.866a.66.66,0,0,0,.657-1.145Z"
                        transform="translate(-7.343 -6.099)"
                      />
                    </g>
                  </g>
                </svg>
                {{ 'nav_grading' | translate }}
              </a>
            </li>

            <!-- <li class="col-6 col-sm-4 ratings_tabs nav-item px-1">
              <a class="tablinks analytics_tablinks ratings_tablink nav-link"
                href="javascript:void(0)"
                routerLink="/vam/commonrating/repair-cost"
                routerLinkActive="active"
                (click)="exteriorHide()">
                <svg class="rating_tab_icon" viewBox="0 0 13.751 21.711">
                  <g transform="translate(-23.973 0.25)">
                    <path class="a"
                      d="M13.07.057A.381.381,0,0,0,12.7.042L6.627,3.1.557.042A.384.384,0,0,0,0,.384V20.822a.383.383,0,0,0,.383.383H12.868a.383.383,0,0,0,.383-.383V.384A.377.377,0,0,0,13.07.057Zm-.582,20.381H.766V1.007L6.453,3.879a.39.39,0,0,0,.345,0l5.687-2.871V20.438Z"
                      transform="translate(37.475 21.205) rotate(180)" />
                    <path class="a"
                      d="M0,.369A.349.349,0,0,0,.326.738H8.433A.349.349,0,0,0,8.759.369.349.349,0,0,0,8.433,0H.326A.349.349,0,0,0,0,.369Z"
                      transform="translate(35.276 3.562) rotate(180)" />
                    <path class="c"
                      d="M10.221,4a3.888,3.888,0,0,0-1.715.355A1.317,1.317,0,0,0,7.66,5.464V6.928a.859.859,0,0,0,.023.137,4.457,4.457,0,0,0-1.121-.137,3.888,3.888,0,0,0-1.715.355A1.317,1.317,0,0,0,4,8.392v2.928a1.317,1.317,0,0,0,.846,1.109,3.888,3.888,0,0,0,1.715.355,3.888,3.888,0,0,0,1.715-.355,1.317,1.317,0,0,0,.846-1.109v-.149a4.289,4.289,0,0,0,1.1.149,3.888,3.888,0,0,0,1.715-.355,1.317,1.317,0,0,0,.846-1.109V5.464a1.317,1.317,0,0,0-.846-1.109A3.888,3.888,0,0,0,10.221,4Zm0,.732a3.2,3.2,0,0,1,1.384.286c.33.166.446.34.446.446s-.116.28-.446.446a3.2,3.2,0,0,1-1.384.286A3.2,3.2,0,0,1,8.838,5.91c-.33-.166-.446-.34-.446-.446s.116-.28.446-.446A3.2,3.2,0,0,1,10.221,4.732ZM8.392,6.5c.039.021.074.049.114.069a3.888,3.888,0,0,0,1.715.355,3.888,3.888,0,0,0,1.715-.355c.04-.02.076-.047.114-.069v.423c0,.106-.116.28-.446.446a3.2,3.2,0,0,1-1.384.286,3.2,3.2,0,0,1-1.384-.286c-.33-.166-.446-.34-.446-.446ZM6.562,7.66a3.2,3.2,0,0,1,1.384.286c.33.166.446.34.446.446s-.116.28-.446.446a3.2,3.2,0,0,1-1.384.286,3.2,3.2,0,0,1-1.384-.286c-.33-.166-.446-.34-.446-.446s.116-.28.446-.446A3.2,3.2,0,0,1,6.562,7.66Zm5.49.309v.423c0,.106-.116.28-.446.446a3.2,3.2,0,0,1-1.384.286,3.477,3.477,0,0,1-1.1-.172v-.56A.859.859,0,0,0,9.1,8.254a4.457,4.457,0,0,0,1.121.137,3.888,3.888,0,0,0,1.715-.355C11.977,8.017,12.013,7.99,12.051,7.968ZM4.732,9.432c.039.021.074.049.114.069a3.888,3.888,0,0,0,1.715.355A3.888,3.888,0,0,0,8.277,9.5c.04-.02.076-.047.114-.069v.423c0,.106-.116.28-.446.446a3.2,3.2,0,0,1-1.384.286A3.2,3.2,0,0,1,5.178,10.3c-.33-.166-.446-.34-.446-.446Zm7.319,0v.423c0,.106-.116.28-.446.446a3.2,3.2,0,0,1-1.384.286,3.535,3.535,0,0,1-1.1-.16V9.718a4.291,4.291,0,0,0,1.1.137A3.888,3.888,0,0,0,11.937,9.5C11.977,9.481,12.013,9.454,12.051,9.432ZM4.732,10.9c.039.021.074.049.114.069a3.888,3.888,0,0,0,1.715.355,3.888,3.888,0,0,0,1.715-.355c.04-.02.076-.047.114-.069v.423c0,.106-.116.28-.446.446a3.2,3.2,0,0,1-1.384.286,3.2,3.2,0,0,1-1.384-.286c-.33-.166-.446-.34-.446-.446Z"
                      transform="translate(39.102 18.324) rotate(180)" />
                  </g>
                </svg>
                {{ 'nav_repair_cost' | translate }}
              </a>
            </li> -->
          </ul>
        </div>

        <div class="overall_exterior_container my-3">
          <!-- <img src="assets/images/overall-exterior.png" class="w-100"> -->
          <div class="rating__scoreModule mx-n3">
            <div
              class="rating__score px-3"
              [class.excellent]="ratingScore >= 5"
              [class.good]="ratingScore >= 4.5 && ratingScore !== 5"
              [class.v-fair]="ratingScore >= 4 && ratingScore <= 4.5"
              [class.fair]="ratingScore >= 3.5 && ratingScore <= 3.999"
              [class.avg]="ratingScore >= 3 && ratingScore <= 3.4"
              [class.b-avg]="ratingScore >= 2.5 && ratingScore <= 2.999"
              [class.poor]="ratingScore >= 2 && ratingScore <= 2.4"
              [class.v-poor]="ratingScore >= 1.5 && ratingScore <= 1.999"
              [class.junk]="ratingScore >= 1 && ratingScore <= 1.4"
            >
              {{ ratingScore > 5 ? '5.0' : (ratingScore | number : '0.1-1') }}
            </div>
            <div class="rating__title px-3">
              <h3 class="fs fs__md-high font-weight-bold text-uppercase">
                {{ 'overall' | translate }}
              </h3>
              <h3 class="fs fs__lg font-weight-bold text-uppercase">
                {{ title + '.' + title | translate }}
              </h3>
            </div>
          </div>
        </div>

        <!-- Scroll Button -->
        <button
          *ngIf="scrollExists && showScrollDownBtn"
          (click)="scrollToBottom()"
          class="button-scroll-down"
          title="Scroll to the bottom"
        >
          <ion-icon name="arrow-down-circle-outline"></ion-icon>
        </button>
        <!-- <ng-container *ngIf="role !== 'evaluator'"> -->
        <div class="dropzone-group my-3" *ngIf="dropzoneOn && role !== 'evaluator'">
          <div class="row mx-n2">
            <div class="col-sm-6 px-2">
              <label for="" class="credential credential__label">Bodyshop attachment:</label>

              <div class="dropzone-group__innerWrapper">
                <div
                  class="dropzone-group__zone mb-3"
                  [class.cursor-not-allowed]="role === 'qc' || role === 'purchasemanager'"
                  *ngIf="!bodyShopDoc.length"
                >
                  <ngx-dropzone
                    [accept]="format"
                    [multiple]="false"
                    [disabled]="role === 'qc' || role === 'purchasemanager'"
                    (change)="uploadPDF($event, 1)"
                  >
                    <ngx-dropzone-label>
                      <span class="icon icon-3x">
                        <img src="/assets/images/icons/pdf.svg" alt="" />
                      </span>
                    </ngx-dropzone-label>
                    <ngx-dropzone-preview
                      *ngFor="let file of bodyShopfiles"
                      [title]="file.name"
                      [removable]="true"
                      (removed)="removePDF(file, 1)"
                    >
                      <ngx-dropzone-label class="w-100">
                        <p class="fs fs__base text-truncate">{{ file.name }}</p>
                        <p class="fs fs__base">({{ file.type }})</p>
                      </ngx-dropzone-label>
                    </ngx-dropzone-preview>
                  </ngx-dropzone>

                  <button
                    type="button"
                    class="btn btn__secondary w-100 mt-2"
                    *ngIf="bodyShopfiles.length"
                    (click)="uploadDocs(bodyShopfiles[0], '1')"
                  >
                    Upload
                    <span
                      class="spinner-grow spinner-grow-sm text-light ml-2"
                      *ngIf="bodyShopUploading"
                    >
                      <span class="sr-only">Loading...</span>
                    </span>
                  </button>
                </div>

                <ul class="dropzone-group__files list-unstyled mb-3" *ngIf="bodyShopDoc.length">
                  <li class="dropzone-group__fileItem" *ngFor="let data of bodyShopDoc">
                    <a
                      [href]="data['document']"
                      target="_blank"
                      class="dropzone-group__fileLink"
                      [title]="data['document']"
                    >
                      <div class="dropzone-group__icon">
                        <span class="icon icon-4x">
                          <img src="/assets/images/icons/pdf-red.svg" alt="" />
                        </span>
                      </div>
                    </a>

                    <div class="dropzone-group__action">
                      <button
                        type="button"
                        class="btn btn__utils bg-cherry"
                        [class.cursor-not-allowed]="role === 'qc' || role === 'purchasemanager'"
                        [disabled]="role === 'qc' || role === 'purchasemanager'"
                        (click)="deleteDocs(data['vehicle_document_id'], '1')"
                      >
                        <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-sm-6 px-2">
              <label for="" class="credential credential__label">Workshop attachment:</label>

              <div class="dropzone-group__innerWrapper">
                <div
                  class="dropzone-group__zone mb-md-3"
                  [class.cursor-not-allowed]="role === 'qc' || role === 'purchasemanager'"
                  *ngIf="!workShopDoc.length"
                >
                  <ngx-dropzone
                    [accept]="format"
                    [multiple]="false"
                    [disabled]="role === 'qc' || role === 'purchasemanager'"
                    (change)="uploadPDF($event, 2)"
                  >
                    <ngx-dropzone-label>
                      <span class="icon icon-3x">
                        <img src="/assets/images/icons/pdf.svg" alt="" />
                      </span>
                    </ngx-dropzone-label>
                    <ngx-dropzone-preview
                      *ngFor="let file of workShopfiles"
                      [title]="file.name"
                      [removable]="true"
                      (removed)="removePDF(file, 2)"
                    >
                      <ngx-dropzone-label class="w-100">
                        <p class="fs fs__base text-truncate">{{ file.name }}</p>
                        <p class="fs fs__base">({{ file.type }})</p>
                      </ngx-dropzone-label>
                    </ngx-dropzone-preview>
                  </ngx-dropzone>

                  <button
                    type="button"
                    class="btn btn__secondary w-100 mt-2"
                    *ngIf="workShopfiles.length"
                    (click)="uploadDocs(workShopfiles[0], '2')"
                  >
                    Upload
                    <span
                      class="spinner-grow spinner-grow-sm text-light ml-2"
                      *ngIf="workShopUploading"
                    >
                      <span class="sr-only">Loading...</span>
                    </span>
                  </button>
                </div>

                <ul class="dropzone-group__files list-unstyled mb-md-3" *ngIf="workShopDoc.length">
                  <li class="dropzone-group__fileItem" *ngFor="let data of workShopDoc">
                    <a
                      [href]="data['document']"
                      target="_blank"
                      class="dropzone-group__fileLink"
                      [title]="data['document']"
                    >
                      <div class="dropzone-group__icon">
                        <span class="icon icon-4x">
                          <img src="/assets/images/icons/pdf-red.svg" alt="" />
                        </span>
                      </div>
                    </a>

                    <div class="dropzone-group__action">
                      <button
                        type="button"
                        class="btn btn__utils bg-cherry"
                        [class.cursor-not-allowed]="role === 'qc' || role === 'purchasemanager'"
                        [disabled]="role === 'qc' || role === 'purchasemanager'"
                        (click)="deleteDocs(data['vehicle_document_id'], '2')"
                      >
                        <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="dropzone-group__loading" *ngIf="documentLoaded">
            <span class="icon icon-5x">
              <img src="/assets/images/icons/ball-triangle.svg" alt="loading..." />
            </span>
          </div>
        </div>
        <!-- </ng-container> -->
      </div>

      <div class="col-md-6">
        <router-outlet> </router-outlet>
        <button
          *ngIf="showScrollUpBtn"
          (click)="scrollToTop()"
          class="button-scroll-up"
          title="Scroll to the top"
        >
          <ion-icon name="arrow-up-circle-outline"></ion-icon>
        </button>
      </div>
    </div>

    <div class="rating__btnGrp mt-4" *ngIf="ratingSubmitOn">
      <div class="row mx-n2">
        <div class="col-sm-6 mb-3 mb-sm-0 mx-auto px-2">
          <!-- <button type="button" class="btn  w-100" (click)="saveData()">{{'save' | translate}}</button> -->
        </div>

        <div class="col-sm-6 px-2 mx-auto" *ngIf="role === 'admin'">
          <a
            href="mailto:?subject=Approve/Disapprove&body=Make - {{
              vinInfo['make_id'].value
            }}%0D%0AModel - {{ vinInfo['model_id'].value }}%0D%0AColor - {{
              vinInfo['exterior_color_id'].value
            }}%0D%0AVIN No - {{ vinInfo['vin_number'].value }}%0D%0ARegistration No - {{
              vinInfo['plate_number'].value
            }}%0D%0ASTATUS - Approved/Conditional Approval/Referred for Review/Rejected%0D%0ARemarks - "
            class="btn btn__secondary w-100"
          >
            {{ 'send_mail' | translate }}
          </a>
        </div>

        <div
          class="col-sm-6 px-2 mx-auto"
          *ngIf="role === 'estimator' || role === 'external_estimator'"
        >
          <a
            href="mailto:?subject=Approve/Disapprove&body=Make - {{
              vinInfo['make_id'].value
            }}%0D%0AModel - {{ vinInfo['model_id'].value }}%0D%0AColor - {{
              vinInfo['exterior_color_id'].value
            }}%0D%0AVIN No - {{ vinInfo['vin_number'].value }}%0D%0ARegistration No - {{
              vinInfo['plate_number'].value
            }}%0D%0ASTATUS - Approved/Conditional Approval/Referred for Review/Rejected%0D%0ARemarks - "
            class="btn btn__secondary w-100"
          >
            {{ 'send_mail' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- <loader [active]="loaded"></loader> -->
</section>
